import { Component, EventEmitter, Output, OnInit, Input } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { TipoCliente } from './tipo-cliente';
import { TipoClienteService } from './tipo-cliente.service';

@Component({
  selector: 'app-tipo-cliente',
  templateUrl: './tipo-cliente.component.html',
  styleUrls: ['./tipo-cliente.component.scss']
})
export class TipoClienteComponent implements OnInit {
  @Input() IdTipoCliente?: number | string;
  tipoCliente: TipoCliente;
  @Output() onTipoClienteInput = new EventEmitter(); // datos del formulario cambian
  @Output() formState = new EventEmitter(); // emite el estado del formulario

  descripcionFormControl = new FormControl('', [
    Validators.required
  ]);

  constructor(
    private tipoClienteService: TipoClienteService
  ) { }

  ngOnInit() {
    this.tipoCliente = new TipoCliente();

    if (this.IdTipoCliente != null) { // si recibo un id solicitar los datos 
      this.formState.emit({ cargando: true });
      this.tipoClienteService.getTiposCliente(
        {
          page: null,
          pageSize: null
        },
        {
          sort: null,
          order: null
        },
        {
          IdTipoCliente: this.IdTipoCliente
        }
      ).subscribe(
        respuesta => {
          if (respuesta.estado == 1 && respuesta.data) {
            var tipoCliente = respuesta.data.tiposCliente[0];
            if (tipoCliente) {
              this.tipoCliente = new TipoCliente(
                tipoCliente.id,
                tipoCliente.descripcion
              );

              this.formState.emit({ // datos encontrados
                estado: 1,
                mensaje: respuesta.mensaje,
                cargando: false
              });
            } else {
              this.formState.emit({ // error al buscar datos
                estado: 3,
                mensaje: 'No se encontraron los datos buscados',
                cargando: false
              });
            }
          }
        },
        error => {
          this.formState.emit({ // error con el servidor
            estado: 2,
            mensaje: error,
            cargando: false
          });
        }
      );
    }
  }

  onInput(): void { // cuando cambia un dato emitimos un evento
    this.onTipoClienteInput.emit();
  }

  getTipoCliente(): TipoCliente {
    // revisar las validaciones
    if (this.descripcionFormControl.hasError('required')) {
      // marcar inputs como usados para mostrar el error si es necesario
      this.descripcionFormControl.markAsTouched();

      throw "Datos incorrectos";
    }

    return this.tipoCliente;
  }
}
